import { getFrame } from './transitionFrames';
import { EffectPreview, RenderFn } from './ScenePreview';
import { noop } from 'utils/noop';
import { getSize } from 'utils/konva';
import { ScalingType } from 'types/Scene';
import { Transition } from 'types/Transitions';

const shapeTransition = (
  isBeginning: boolean,
  transition: Transition,
  duration: number
): EffectPreview => {
  const afterFrameDrawn: RenderFn = (ctx, preview) => {
    const relativeTime = isBeginning
      ? Math.min(preview.time, duration)
      : preview.time - (preview.settings.duration - duration);

    if (relativeTime > 0) {
      const [frame, width, height] = getFrame(
        transition,
        isBeginning ? relativeTime + duration : relativeTime
      );

      const [w, h] = getSize(ScalingType.FILL, ctx.canvas.width, ctx.canvas.height, width, height);

      ctx.drawImage(frame, (ctx.canvas.width - w) / 2, (ctx.canvas.height - h) / 2, w, h);
    }
  };

  return { beforeFrameDrawn: noop, afterFrameDrawn };
};

export default shapeTransition;
